import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'chevronRightSmall',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-chevron-right-small wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M13.703 12L9.128 7.39a.44.44 0 0 1 0-.62l.635-.64a.44.44 0 0 1 .622-.002l.002.002 5.482 5.523a.44.44 0 0 1 .127.347.44.44 0 0 1-.127.347l-5.482 5.523a.44.44 0 0 1-.622.002l-.002-.002-.635-.64a.44.44 0 0 1 0-.62L13.703 12z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-chevron-right-small.svg',
    category: 'Core',
    tags: ['navigation', 'arrow'],
};
export default icon;
